import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '../../common/constants';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import FontAwesomeIcon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Search from '../Search';
import { selectSearch } from '../../store/selectors/search';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import ConfigureCommonAreaForm from '../../components/ConfigureCommonAreaForm';



class CommonAreasTable extends Component {
  state={
    showOverlay:false
  }
  
    render() {
        const { commonAreas,property,user, onSearch, search} = this.props;
        const { showOverlay } = this.state;
    return (
      <>
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Common Areas..."
            onChange={onSearch}
          />{
            user.roles[0].role.name === "Home Owner" ||  user.roles[0].role.name === "Occupant" ? null : <Button
            color="teal"
            label="Configure Common Areas"
            onClick={() => this.setState({showOverlay:true})}
            icon={(
              <FontAwesomeIcon
                glyph="home"
                weight="light"
                size="small"
              />
            )}
            size="small"
          />
          }
          
        </Actions>
        {commonAreas && commonAreas.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Areas',
                  accessor: 'name',
                  cell: data => (
                    <Link
                      to={PATHS.COMMON_AREA_VIEW.replace(':id', data.id+'&'+property.id)}
                    >
                      {data && data.customLabel ? data.customLabel : data.name}
                    </Link>
                  )
                } 
              ]}
              data={commonAreas}
            />
          </>
        ) : (
          <Empty
            headline="No Common Areas yet"
            strapline="All common areas you add will be listed here so it’s easier for you to manage."
            searchIsActive={search && search.suites ? search.suites : ''}
            cta={(this.props.user.roles[0].role.name === "Home Owner" || user.roles[0].role.name === "Occupant" ? null : 
              <Button
                color="teal"
                onClick={() => this.setState({ showOverlay: true })}
                icon={(
                  <FontAwesomeIcon
                    glyph="home"
                    weight="light"
                    size="small"
                  />
                )}
                label="Configure Common Areas"
                size="small"
              />
            )}
            image={(
              <img
                alt="No common areas yet"
                src="/assets/empty/suites.svg"
              />
            )}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={(
            <ConfigureCommonAreaForm
              onClose={() => {this.setState({showOverlay:false}); setTimeout(() => {
                this.props.triggerCommonAreas('')
              },1000);}}
              property={property}
             
            />
          )}
        />

    </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  user:selectAuthenticatedUser(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommonAreasTable)

